<template>
  <div v-if="cadastroMembro == false">
    <h3>Tipo de vínculo</h3>
    <div class="row">
      <form-toggle
        v-model="dinamicaFamiliar.estudo_acompanhamento"
        label="Em estudo e acompanhamento da situação familiar"
      />
      <form-toggle
        v-model="dinamicaFamiliar.crianca_orfao"
        label="Criança/adolescente órfão"
      />
      <form-toggle
        v-model="dinamicaFamiliar.familia_acolhedora"
        label="Serviço Família Acolhedora"
      />
      <form-toggle
        v-model="dinamicaFamiliar.preparacao_reintegracao_natural"
        label="Preparação para reintegração familiar (família natural)"
      />
      <form-toggle
        v-model="dinamicaFamiliar.preparacao_reintegracao_extensa"
        label="Preparação para reintegração familiar (família extensa)"
      />
      <form-toggle
        v-model="dinamicaFamiliar.poder_fam_destituido"
        label="Poder familiar destituído"
      />
      <form-toggle
        v-model="dinamicaFamiliar.processo_guarda"
        label="Em processo de guarda/tutela/adoção"
      />

      <div class="col-12 px-5" v-if="dinamicaFamiliar.processo_guarda == 1">
        <form-toggle
          v-model="dinamicaFamiliar.processo_tipo_guarda"
          label="Guarda"
        />
        <div
          class="col-12 px-5"
          v-if="dinamicaFamiliar.processo_tipo_guarda == 1"
        >
          <div class="alert alert-info">
            A guarda estatutária é concedida quando, pela ausência, omissão ou
            abuso por parte dos pais ou responsáveis, ocorre a perda do poder
            familiar. Para a colocação do menor de idade em família substituta,
            deve haver a situação de risco e a necessidade de aplicar essa
            medida de proteção. Pode-se classificar a Guarda Estatutária, em
            definitiva ou temporária. Será definitiva quando houver o desejo por
            parte do guardião de ter a criança ou o adolescente como membro da
            família substituta, com todos os direitos e deveres advindos deste
            instituto. Já a guarda temporária, atende a uma situação limitada
            por termo ou condição. Findo o termo ou a condição, a guarda findará
            também. É o caso de guarda concedida antes da adoção por uma outra
            família.
          </div>
          <div class="d-flex align-items-center">
            <input
              type="radio"
              name="processo_tipo_guarda"
              v-model="dinamicaFamiliar.processo_tipo_guarda_definitiva"
            />
              <label class="ml-2">Guarda estatutária - Definitiva</label>
          </div>
           
          <div class="d-flex align-items-center">
            <input
              type="radio"
              name="processo_tipo_guarda"
              v-model="dinamicaFamiliar.processo_tipo_guarda_temporaria"
            />
              <label class="ml-2">Guarda estatutária - Temporária</label>
          </div>
          <form-select
            v-model="dinamicaFamiliar.guarda_guardiao"
            class="px-0"
            label="Guardião"
            :itens="familiares"
          />
          <button
            class="btn btn-sm btn-sm btn-primary"
            @click="cadastroMembro = true"
          >
            <i class="fas fa-plus-square" />
            {{ $t("Ou Cadastre um Guardião") }}
          </button>
          <form-input
            v-model="dinamicaFamiliar.guarda_numero"
            class="px-0"
            label="Número do processo de Guarda"
          />
          <form-select
            v-model="dinamicaFamiliar.guardiao_vinculo_familiar"
            class="px-0"
            label="A guardiã tem vínculo familiar com a criança e o adolescente?"
            :itens="$root.arrays.pergunta"
          />
          <form-select
            v-model="dinamicaFamiliar.guardiao_vinculo_intitucional"
            class="px-0"
            label="A guardiã tem vínculo institucional com a criança e o adolescente?"
            :itens="$root.arrays.pergunta"
          />
          <form-select
            v-if="dinamicaFamiliar.guardiao_vinculo_intitucional == 1"
            v-model="dinamicaFamiliar.guardiao_unidade_intitucional"
            class="px-0"
            label="Qual o Serviço ou a Organização da Sociedade Civil (OSC) o Guardião está vinculado?"
            :itens="unidades"
          />
        </div>
        <form-toggle
          v-model="dinamicaFamiliar.processo_tipo_tutela"
          label="Tutela"
        />
        <div
          class="col-12 px-5"
          v-if="dinamicaFamiliar.processo_tipo_tutela == 1"
        >
          <form-select
            v-model="dinamicaFamiliar.nome_tutor"
            class="px-0"
            label="Tutor"
            :itens="familiares"
          />
          <button
            class="btn btn-sm btn-sm btn-primary"
            @click="cadastroMembro = true"
          >
            <i class="fas fa-plus-square" />
            {{ $t("Ou Cadastre um Tutor") }}
          </button>
        </div>
        <form-toggle
          v-model="dinamicaFamiliar.processo_tipo_adocao"
          label="Adoção"
        />
        <div
          class="col-12 px-5"
          v-if="dinamicaFamiliar.processo_tipo_adocao == 1"
        >
          <form-input
            v-model="dinamicaFamiliar.adocao_numero_processo"
            class="px-0"
            label="Número do processo"
          />
          <form-calendar
            v-model="dinamicaFamiliar.data_inicio_adocao"
            class="px-0"
            label="Início do Processo"
          />
          <form-calendar
            v-model="dinamicaFamiliar.data_desacolhimento_adocao"
            class="px-0"
            label="Desacolhimento da criança - apontar data"
          />
        </div>
      </div>
      <form-toggle
        v-model="dinamicaFamiliar.sem_informacao"
        label="Sem informação da família"
      />
    </div>
    <div
      class="row d-flex justify-content-between px-3"
      v-if="dinamicaFamiliar.poder_fam_destituido != 1"
    >
      <h3 class="mt-2">Composição Familiar</h3>
      <button
        class="btn btn-sm btn-sm btn-primary"
        @click="cadastroMembro = true"
      >
        <i class="fas fa-plus-square" />
        {{ $t("Cadastrar") }}
      </button>
    </div>
    <div
      class="col-12 px-0"
      v-if="
        dinamicaFamiliar.poder_fam_destituido != 1 &&
        dinamicaFamiliar.sem_informacao != 1
      "
    >
      <Composicao :item="item" />
    </div>
    <div class="row mt-3">
      <form-select
        v-model="dinamicaFamiliar.intereressados_acolher"
        :itens="$root.arrays.pergunta"
        label="Entre os parentes identificados, há interessados em acolher a criança/adolescente?"
      />
      <form-select
        v-model="dinamicaFamiliar.unidade_acolhimento_proxima"
        :itens="$root.arrays.pergunta"
        label="A unidade de acolhimento localiza-se próximo à residência dos pais?"
      />
      <form-select
        v-model="dinamicaFamiliar.residia_familia_origem"
        :itens="$root.arrays.pergunta"
        label="No momento do acolhimento residia com a família de origem? "
      />
    </div>
    <div class="row" v-if="dinamicaFamiliar.residia_familia_origem == 2">
      <form-input v-model="dinamicaFamiliar.nome" label="Nome" grid="8" />
      <form-input v-model="dinamicaFamiliar.vinculo" label="Vinculo" grid="4" />
      <form-input
        type="number"
        v-model="dinamicaFamiliar.idade"
        label="Idade"
        grid="2"
      />
      <form-input
        v-model="dinamicaFamiliar.escolaridade"
        label="Escolaridade"
        grid="6"
      />
      <form-input
        v-model="dinamicaFamiliar.ocupacao"
        label="Ocupação"
        grid="4"
      />
      <form-input
        v-model="dinamicaFamiliar.endereco"
        label="Endereço"
        grid="8"
      />
      <form-input v-model="dinamicaFamiliar.renda" label="Renda" grid="4" />
      <form-input
        v-model="dinamicaFamiliar.telefone"
        label="Telefone"
        grid="8"
      />
    </div>
    <div class="row">
      <form-textarea
        label="Informações adicionais sobre a família"
        v-model="dinamicaFamiliar.informacoes_adicionais"
      />
    </div>
    <h3 class="mt-2">Dinâmica Familiar</h3>
    <div class="row">
      <form-select
        v-model="dinamicaFamiliar.familia_interagem"
        :itens="$root.arrays.pergunta"
        label="Interagem entre si?"
      />
      <form-input
        v-if="dinamicaFamiliar.familia_interagem == 1"
        v-model="dinamicaFamiliar.forma_interacao"
        label="Se afirmativo, de que forma?"
      />
      <form-select
        v-model="dinamicaFamiliar.demontra_preferencia"
        :itens="$root.arrays.pergunta"
        label="Demonstram alguma preferência?"
      />
      <form-select
        v-model="dinamicaFamiliar.exclusao_aceitacao_membro"
        :itens="$root.arrays.pergunta"
        label="Há exclusão, não aceitação de algum membro? "
      />
      <!-- <form-select
				v-model="dinamicaFamiliar.isolamento_membro"
				:itens="$root.arrays.pergunta"
				label="solamento de um dos membros?"
			/> -->
      <form-select
        v-model="dinamicaFamiliar.tomada_atitude"
        :itens="$root.arrays.acolhimento_tomada_atitude"
        label="Tomada de atitude em relação ao filho:"
      />
    </div>
    <DinamicaRelacao :item="item" @reload="$emit('reload')" />
    <div class="row">
      <form-select
        v-model="dinamicaFamiliar.dificuldade_relacao"
        :itens="$root.arrays.pergunta"
        label="Dificuldade em estabelecer a relação interpessoal?"
      />
      <form-input
        v-if="dinamicaFamiliar.dificuldade_relacao == 1"
        v-model="dinamicaFamiliar.dificuldade_por_que"
        label="Qual o motivo?"
      />
      <form-textarea
        v-model="dinamicaFamiliar.intervencao_percepcao"
        label="Intervenções e percepções do profissional durante o acompanhamento "
      />
    </div>
    <div class="row pt-4 px-0 d-flex justify-content-end">
      <div class="col-auto px-2 text-right">
        <button class="btn btn-success btn-dinamica" @click="submit">
          <i class="mdi mdi-content-save" />
          {{ $t("Salvar") }}
        </button>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row animate__animated animate__fadeIn">
      <div class="col-md-9">
        <h4 class="font-weight-bold">Cadastrar usuário</h4>
      </div>
      <div class="col-md-3 text-right">
        <button
          class="btn active btn-outline-secondary btn-sm"
          @click="cadastroMembro = false"
        >
          <i class="mdi mdi-arrow-left" />
          {{ $t("Voltar") }}
        </button>
      </div>
      <div class="col-md-12">
        <CadastrarPessoa
          :familia="item.familia"
          @voltar="cadastroMembro = false"
          @reload="$emit('reload')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Composicao from "./Composicao";
import DinamicaRelacao from "./DinamicaRelacao";
import CadastrarPessoa from "@modules/Familia/Resources/assets/js/includes/Abas/composicao/Cadastrar.vue";
export default {
  components: { Composicao, DinamicaRelacao, CadastrarPessoa },
  props: ["item"],
  data() {
    return {
      loading: false,
      cadastroMembro: false,
      dinamicaFamiliar: {},
      familiares: [],
      unidades: [],
    };
  },
  watch: {
    item() {
      this.setFamiliares();
    },
  },
  mounted() {
    if (this.item.dinamicaFamiliar != null) {
      this.dinamicaFamiliar = this.item.dinamicaFamiliar;
    }
    this.setFamiliares();
    this.getUnidades();
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-dinamica"));
      ladda.start();
      this.item.dinamicaFamiliar = this.dinamicaFamiliar;
      this.$emit("submit");
      setInterval(() => {
        ladda.stop();
      }, 2000);
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/saica`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    setFamiliares() {
      this.familiares = [];

      const familiares =
        this.item &&
        this.item.familia &&
        Array.isArray(this.item.familia.familiares)
          ? this.item.familia.familiares
          : [];

      if (familiares.length > 0) {
        this.familiares = familiares.map((e) => {
          return {
            id: `${e.nome_completo} == ${e.id}`,
            value: `${e.nome_completo} - <b>${e.idade} ano(s)</b>`,
          };
        });
      }
    },
  },
};
</script>
